window.addEventListener('DOMContentLoaded', () => {
    const burgerBtn = document.querySelector('#header .header__buttons-burger')
    const nav = document.querySelector('#header')
    const html = document.querySelector('html')

    burgerBtn.addEventListener('click', () => {
        nav.classList.toggle('header--open')
        html?.classList?.toggle('header-open')
    })

    const header = document.querySelector('.header')

    let lastScrollTop = 0
    window.addEventListener('scroll', (e) => {
        const SCROLL_OFFSET = 30
        let st = window.scrollY
        html?.classList?.remove('header-open')
        nav.classList.remove('header--open')
        if (st >= SCROLL_OFFSET) {
            header?.classList?.add('header--scroll')
            if (st > lastScrollTop && st >= 600) {
                header?.classList?.add('header--scroll-down')
            } else {
                header?.classList?.remove('header--scroll-down')
            }
        } else {
            header?.classList?.remove('header--scroll', 'header--scroll-down', 'header--scroll-bottom')
        }
        lastScrollTop = st
    })
})
